<template>
    <div>
        <el-button
                icon="el-icon-right"
                type="info"
                @click="$router.push({name:'booking/normal', params:{roomId}})"
        >
            移至借用介面
        </el-button>
        <el-row>
            <el-col :lg="4" :sm="24" :xl="4" class="grid">
                <el-select
                        @change="onChangeRoom"
                        placeholder="請選擇教室"
                        v-model="roomId"
                        filterable
                >
                    <el-option
                            :key="room.id"
                            :label="room.name"
                            :value="room.id"
                            v-for="room in rooms"
                    >
                    </el-option>
                </el-select>
            </el-col>
            <el-col :lg="8" :sm="24" :xl="6" class="grid">
                <el-button-group>
                    <el-button
                            @click="prevWeek"
                            icon="el-icon-arrow-left"
                    >
                        上一周
                    </el-button>
                    <el-button
                            @click="current"
                            icon="el-icon-date"
                    >
                        本周
                    </el-button>
                    <el-button
                            @click="nextWeek"
                            icon="el-icon-arrow-right"
                    >
                        下一周
                    </el-button>
                </el-button-group>
            </el-col>
            <el-col :lg="10" :sm="24" :xl="10" class="grid">
                <span>週次快選: </span>
                <el-date-picker
                        v-model="week"
                        type="week"
                        format="週 WW"
                        placeholder="請選擇週次"
                        :pickerOptions="pickerOptions"
                        :clearable="false"
                        :editable="false"
                        @change="weekChange"

                >
                </el-date-picker>
            </el-col>
        </el-row>
        <h3 style="text-align: center;">期間: {{weeks[0] | shortDate}} ~ {{weeks[6] | shortDate}}</h3>
        <small >※點擊空堂處，可快速借用</small>
        <timetable
                :is-date-selectable="isValidDate"
                :weeks="weeks"
                :periodsDefs="periodsDefs"
                :timePlots="timePlots"
                :on-cell-click="onCellClick"
        ></timetable>
    </div>
</template>

<script>
    import Timetable from '../Timetable/TimetableContainer';
    import QueryMixin from './QueryMixin';
    import {isPeriodCollided} from '../../utilities';

    export default {
        name: 'TimetableQuery',
        data: () => ({

        }),
        mixins:[QueryMixin],
        components: {
            Timetable
        },

        computed: {

        },
        filters: {
        },
        watch: {
            async rooms(current) {
                this.roomId = (current || [{id: ''}])[0].id;
                await this.refresh();
            }
        },
        methods: {
            async onChangeRoom() {
                await this.refresh();
            },

            async onCellClick(data){
                const {isValid, isPast, date, period, weekday} = data;
                const {roomId} = this;
                const timeSlotOfWd = this.timePlots[weekday > 5 ? weekday + 1: weekday];
                if(isValid && !isPast && this.isValidDate(date) &&
                    !timeSlotOfWd
                    .some(ts => isPeriodCollided(ts, {weekday, begin: period, end: period}))
                ){
                    this.$router.push({
                        name: 'booking/normal',
                        params:{
                            roomId,
                            date,
                            periods:[period, period]
                        }
                    })
                }
            }
        },

        async created() {
            if (this.rooms && this.rooms.length > 0) {
                this.roomId = this.rooms[0].id;
                await this.refresh();
            }
            const {schoolYear, semester} = this;
            await this.getWeekRanges({
               schoolYear,
               semester
            });
        }
    }
</script>

<style scoped>
    .grid {
        padding: 10px;
    }
</style>
